<template>
  <v-app>
    <v-main>
      <ShipmentRequests/>
    </v-main>
  </v-app>
</template>

<script>
import ShipmentRequests from './components/ShipmentRequests';

export default {
  name: 'App',

  components: {
    ShipmentRequests,
  },

  data: () => ({
    //
  }),
};
</script>
